import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_header = _resolveComponent("top-header")
  const _component_search = _resolveComponent("search")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_top_header),
    _createVNode(_component_search, { page: "home" })
  ], 64))
}